<template>
  <home-section
    :title="section.title"
    :subtitle="section.subtitle"
    :loading="loading"
    :error="error"
    :is-empty="!items.length"
    variant="authors"
    skeleton-variant="authors"
    :skeleton-count="6"
    @retry="$emit('retry', section)"
  >
    <home-author-rail :items="items" />
  </home-section>
</template>

<script>
import HomeSection from "./HomeSection.vue";
import HomeAuthorRail from "@/components/home/rails/HomeAuthorRail.vue";

export default {
  name: "HomeAuthorSection",
  components: { HomeSection, HomeAuthorRail },
  props: {
    section: { type: Object, required: true },
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },
};
</script>
